module.exports = __webpack_public_path__ + "img/cardpay.5a3ef9d9.png";